var _path, _path2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUnwrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 7.83754C13.7945 7.56162 13.7945 7.11428 13.5186 6.83837C13.2427 6.56245 12.7953 6.56245 12.5194 6.83837L13.5186 7.83754ZM10.3554 10.0016L9.85579 9.502C9.57988 9.77791 9.57988 10.2253 9.85579 10.5012L10.3554 10.0016ZM12.5194 13.1648C12.7953 13.4407 13.2427 13.4407 13.5186 13.1648C13.7945 12.8889 13.7945 12.4415 13.5186 12.1656L12.5194 13.1648ZM12.5194 6.83837L9.85579 9.502L10.855 10.5012L13.5186 7.83754L12.5194 6.83837ZM9.85579 10.5012L12.5194 13.1648L13.5186 12.1656L10.855 9.502L9.85579 10.5012Z",
    fill: "url(#paint0_linear_175_560)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78602 6.92842C10.0619 6.65251 10.0619 6.20516 9.78602 5.92925C9.51011 5.65333 9.06277 5.65333 8.78685 5.92925L9.78602 6.92842ZM5.71501 10.0003L5.21543 9.50067C4.93951 9.77659 4.93951 10.2239 5.21543 10.4998L5.71501 10.0003ZM8.78685 14.0713C9.06277 14.3472 9.51011 14.3472 9.78602 14.0713C10.0619 13.7954 10.0619 13.348 9.78602 13.0721L8.78685 14.0713ZM8.78685 5.92925L5.21543 9.50067L6.2146 10.4998L9.78602 6.92842L8.78685 5.92925ZM5.21543 10.4998L8.78685 14.0713L9.78602 13.0721L6.2146 9.50067L5.21543 10.4998Z",
    fill: "url(#paint1_linear_175_560)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99999,
    cy: 9.99999,
    r: 9.29347,
    stroke: "url(#paint2_linear_175_560)",
    strokeWidth: 1.41304
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_560",
    x1: 13.019,
    y1: 12.6652,
    x2: 8.90574,
    y2: 8.93754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_175_560",
    x1: 9.28644,
    y1: 13.5717,
    x2: 3.77132,
    y2: 8.57358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_175_560",
    x1: 20,
    y1: 0,
    x2: -3.79218,
    y2: 13.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnwrap);
export default __webpack_public_path__ + "static/media/icon_unwrap.6b8b2dcea428c8ab073e137406957bf1.svg";
export { ForwardRef as ReactComponent };